import { useMemo } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';

export default function useBestFittingImage(
  deviation: PapiDeviation,
  containerWidth: number,
  containerHeight: number
) {
  const pickedImage = useMemo(
    () =>
      MediaService.getFullviewForSize(
        deviation,
        containerWidth,
        containerHeight
      ),
    [containerHeight, containerWidth, deviation]
  );

  return pickedImage;
}
